import type { Channels } from '@eureka/shared/login-sdk';
import { loginSDK, SDK_ENV } from '@eureka/shared/login-sdk';
import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';
import type { I18n } from 'vue-i18n';

import { initCookieService } from './home/use-visitor-cookies';

export function useLoginSdk(i18n: I18n, channels: Channels = {}) {
  const sdkEnv = [DeployEnv.US, DeployEnv.EU].includes(REGION) ? SDK_ENV.US : SDK_ENV.CN;
  loginSDK.setI18n(i18n).setEnv(sdkEnv).setChannels(channels);
  loginSDK.handleThirdPartyLoginErrors();

  const openLoginDialog = (silence?: boolean, limit?: boolean, onClose?: () => void, guestLimit?: boolean) => {
    loginSDK
      .open({
        silence,
        withoutClose: false,
        ...(limit !== undefined && { limit }),
        ...(guestLimit !== undefined && { guestLimit }),
        ...(onClose !== undefined && { onClose }),
      })
      .then(async () => {
        window.location.reload();
        initCookieService.init();
      });
  };

  return { openLoginDialog };
}
